import { areaPath, type Area } from "@/routes/paths";

const AREA_KEY = (username: string) => `safers.last-area:${username}`;
const SITE_KEY = (username: string) => `safers.last-site:${username}`;

const AREAS: Area[] = ["control", "health", "cctv"];

function read(store: Storage, key: string): string | null {
  try {
    return store.getItem(key);
  } catch {
    return null;
  }
}

function write(store: Storage, key: string, value: string): void {
  try {
    store.setItem(key, value);
  } catch {
    return;
  }
}

function remove(store: Storage, key: string): void {
  try {
    store.removeItem(key);
  } catch {
    return;
  }
}

export function readLastArea(username: string | null): Area | null {
  if (!username) return null;
  const raw = read(localStorage, AREA_KEY(username));
  return AREAS.includes(raw as Area) ? (raw as Area) : null;
}

export function writeLastArea(username: string | null, area: Area): void {
  if (!username) return;
  write(localStorage, AREA_KEY(username), area);
}

export function readLastSite(username: string | null): string | null {
  if (!username) return null;
  return read(sessionStorage, SITE_KEY(username));
}

export function writeLastSite(username: string | null, siteId: string): void {
  if (!username) return;
  write(sessionStorage, SITE_KEY(username), siteId);
}

export function clearLastVisit(username: string | null): void {
  if (!username) return;
  remove(localStorage, AREA_KEY(username));
  remove(sessionStorage, SITE_KEY(username));
}

export function landingPath(username: string | null): string {
  const area = readLastArea(username);
  if (!area) return areaPath("control");
  return areaPath(area, readLastSite(username));
}
